import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { delay, of, Subscription } from 'rxjs';

@Component({
  selector: 'forrest-notication-snack-bar',
  templateUrl: './notication-snack-bar.component.html',
  styleUrls: ['./notication-snack-bar.component.scss']
})
export class NoticationSnackBarComponent implements OnDestroy {

  private subscriptions: Subscription[] = [];

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) { }

  ngOnInit() {

    if (!this.data.showUndoButton || (this.data.undoButtonDuration >= this.data.duration)) {
      return;
    }

    this.subscriptions.push(
      this.delayForUndoButton(this.data.undoButtonDuration).subscribe(() => {
        this.data.showUndoButton = false;
      })
    )
  }

  delayForUndoButton(timeToDelay: number | Date) {
    return of('').pipe(delay(timeToDelay));
  }

  onDismissWithAction() {
    this.data.snackBar.dismiss();
  }

  public onDismiss() {
    this.data.snackBar.dismiss();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
